export const NOT_STARTED = 1;
export const FIRST = 2;
export const FIRST_BREAK = 3;
export const SECOND = 4;
export const SECOND_BREAK = 5;
export const THIRD = 6;
export const THIRD_BREAK = 7;
export const FOURTH = 8;
export const FOURTH_BREAK = 9;
export const FIFTH = 10;
export const FIFTH_BREAK = 11;
export const SIXTH = 12;
export const SIXTH_BREAK = 13;
export const SEVENTH = 14;
export const SEVENTH_BREAK = 15;
export const FULL_TIME = 16;
export const OVERTIME = 17;
export const OVERTIME_FINISHED = 18;
export const PENALTIES = 19;
export const FIRST_EXTRA = 20;
export const FIRST_EXTRA_BREAK = 21;
export const SECOND_EXTRA = 22;
export const SECOND_EXTRA_BREAK = 23;
export const FINISHED = 24;

export const ROUND_FIRST = 1;
export const ROUND_SECOND = 2;
export const ROUND_THIRD = 3;
export const ROUND_FOURTH = 4;
export const ROUND_FIFTH = 5;
export const ROUND_SIXTH = 6;
export const ROUND_SEVENTH = 7;
export const ROUND_EIGHTH = 8;
export const ROUND_NINTH = 9;
export const ROUND_TENTH = 10;
export const ROUND_ELEVENTH = 11;
export const ROUND_TWELFTH = 12;

export const LAP_FIRST = 1;
export const LAP_SECOND = 2;
export const LAP_THIRD = 3;
export const LAP_FOURTH = 4;
export const LAP_FIFTH = 5;
export const LAP_SIXTH = 6;
export const LAP_SEVENTH = 7;
export const LAP_EIGHTH = 8;


// WEBPACK FOOTER //
// ./js/constants/Period.js